module.exports = "https://cdn2-fs.clearscore.com/flux/images/ded398cb3e05e81df944459eaee78a07.jpg";